import React from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";

const style={
    currencyHead:{
        width:'9rem',
        padding:'0px'
    },
    currencyPer:{
        width:'50%',
        height:'2rem',
        display:'flex',
        alignItems:'center',
        justifyContent:'center'
    },
    red:{
        backgroundColor:'#e30853'
    },
    lightRed:{
        backgroundColor:'#f44336'
    },
    orange:{
        backgroundColor:'#ff9800'
    },
    yellow:{
        backgroundColor:'#ffeb3b'
    },
    darkYellow:{
        backgroundColor:'#f7df10'
    },
    darkerYellow:{
        backgroundColor:'#f1d800'
    },
    lighterGreen:{
        backgroundColor:'#cddc39'
    },
    lightGreen:{
        backgroundColor:'#aebd1b'
    },
    green:{
        backgroundColor:'#8bc34a'
    },
    greener:{
        backgroundColor:'#6fb321'
    },
    darkGreen:{
        backgroundColor:'#59a700'
    }
  }

function CountriesPercentage() {
    const cacheRtl = createCache({
        key: "muirtl",
        // prefixer is the only stylis plugin by default, so when
        // overriding the plugins you need to include it explicitly
        // if you want to retain the auto-prefixing behavior.
        stylisPlugins: [prefixer, rtlPlugin]
      });
  return (
    <CacheProvider value={cacheRtl}>
        <div className="container">
            <div style={{width:'100%',display:'flex',justifyContent:'center'}}>
                <TableContainer component={Paper} sx={{display:'flex',justifyContent:'center',width:'fit-content'}}>
                    <Table aria-label="simple table">
                        <TableHead>
                        <TableRow>
                            <TableCell className='ratesTh' align="center">مبدا</TableCell>
                            <TableCell className='ratesTh' align="center">ارز</TableCell>
                            <TableCell className='ratesTh' align="center">
                                <Box>مقصد</Box>
                                <Box>ارز</Box>
                                <Box>نوع</Box>
                            </TableCell>
                            <TableCell className='ratesTh' align="center" sx={style.currencyHead}>
                                <Box>امارات</Box>
                                <Box>درهم</Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>حساب</Box>
                                    <Box sx={style.currencyPer}>نقد</Box>
                                </Box>
                            </TableCell>
                            <TableCell className='ratesTh' align="center" sx={style.currencyHead}>
                                <Box>ترکیه</Box>
                                <Box>یورو</Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>حساب</Box>
                                    <Box sx={style.currencyPer}>نقد</Box>
                                </Box>
                            </TableCell>
                            <TableCell className='ratesTh' align="center" sx={style.currencyHead}>
                                <Box>ترکیه</Box>
                                <Box>دلار</Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>حساب</Box>
                                    <Box sx={style.currencyPer}>نقد</Box>
                                </Box>
                            </TableCell>
                            <TableCell className='ratesTh' align="center" sx={style.currencyHead}>
                                <Box>چین</Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>یورو</Box>
                                    <Box sx={style.currencyPer}>دلار</Box>
                                </Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>حساب</Box>
                                    <Box sx={style.currencyPer}>نقد</Box>
                                </Box>
                            </TableCell>
                            <TableCell className='ratesTh' align="center" sx={style.currencyHead}>
                                <Box>چین</Box>
                                <Box>یوان</Box>
                                <Box sx={{display:'flex'}}>
                                    <Box sx={style.currencyPer}>شخص</Box>
                                    <Box sx={style.currencyPer}>شرکت</Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">امارات</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">درهم</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">
                                    <Box>حساب</Box>
                                    <Box>نقد</Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed} >0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.red}>0.3%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed}>0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.red}>0.3%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed}>0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed}>0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed}>0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightRed}>0.5%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lighterGreen}>2%</Box>
                                        <Box sx={style.currencyPer} style={style.green}>3%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.darkerYellow}>1.5%</Box>
                                        <Box sx={style.currencyPer} style={style.lightGreen}>2.5%</Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">ترکیه</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">یورو</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">
                                    <Box>حساب</Box>
                                    <Box>نقد</Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.darkYellow}>1.3%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.green}>3%</Box>
                                        <Box sx={style.currencyPer} style={style.darkGreen}>4%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightGreen}>2.5%</Box>
                                        <Box sx={style.currencyPer} style={style.greener}>3.5%</Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">ترکیه</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">دلار</TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">
                                    <Box>حساب</Box>
                                    <Box>نقد</Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.darkYellow}>1.3%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.green}>3%</Box>
                                        <Box sx={style.currencyPer} style={style.darkGreen}>4%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.lightGreen}>2.5%</Box>
                                        <Box sx={style.currencyPer} style={style.greener}>3.5%</Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{padding:0}}className='ratesTh' align="center">چین</TableCell>
                                <TableCell sx={{padding:0}}className='ratesTh' align="center">
                                    <Box>یورو</Box>
                                    <Box>دلار</Box>
                                </TableCell>
                                <TableCell sx={{padding:0}} className='ratesTh' align="center">
                                    <Box>حساب</Box>
                                    <Box>نقد</Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer}  style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                        <Box sx={style.currencyPer} style={style.orange}>0.7%</Box>
                                    </Box>
                                </TableCell>
                                <TableCell  align="center" sx={style.currencyHead}>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.darkerYellow}>1.5%</Box>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Box sx={style.currencyPer} style={style.yellow}>1%</Box>
                                        <Box sx={style.currencyPer} style={style.darkerYellow}>1.5%</Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    </CacheProvider>
    
  )
}

export default CountriesPercentage
